import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from 'react-router-dom';
import moment from "moment";
import lodash from 'lodash';

import FetchModule from "../../../Model/Network/FetchModule";
import AppliedTimeInput from "../Component/AppliedTimeInput";
import SubmitBox from "../Model/SubmitBox";

import WhiteLeftArrow from '../../../Image/WhiteLeftArrow.png';
import ProfilePath from '../../../Image/DefaultProfile.png';
import FirstPlaceImg from '../../../Image/FirstPlace.png';
import SecondPlaceImg from '../../../Image/SecondPlace.png';
import ThirdPlaceImg from '../../../Image/ThirdPlace.png';
import RightImg from '../../../Image/NotAvailableRight.png';
import NoneProfile from '../../../Image/NoneProfile.png';
import CalenderIcon from '../../../Image/GrayCalenderIcon.png';
import EmptyLogo from '../../../Image/EventerEmptyLogo.png';
import JudgeSelectBox from "../Component/JudgeSelectBox";
import JudgeBox from "../Model/JudgeBox";
import JudgeNoteTextArea from "../Component/JudgeNoteTextArea";
import AppliedDateSelectModal from "../Model/AppliedDateSelectModal";
import LoadingView from "../Model/LoadingView";
import PlaylistVideoBox from "../../Share/PlaylistVideoBox";


export default function LeaderBoardPage(props) {

  const navigate = useNavigate();
  const params = useParams();

  const [isEdit, setIsEdit] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);

  const [organizerId, setOrganizer] = useState('');
  const [eventTitle, setEventTitle] = useState('');
  const [eventProfile, setEventProfile] = useState('');
  const [columns, setColumns] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [clickedScoreRuleId, setClickedScoreRuleId] = useState(-1);
  const [clickedSelectOptionId, setClickedSelectOptionId] = useState(0);
  const [ranks, setRanks] = useState([]);
  const [clickedRankDetail, setClickedRankDetail] = useState(undefined);
  const [clickedRankDetailIndex, setClickedRankDetailIndex] = useState(-1);
  const [judges, setJudges] = useState([]);

  const [isClickedAppliedDate, setIsClickedAppliedDate] = useState(false);
  const [appliedDate, setAppliedDate] = useState(moment());
  const [appliedTime, setAppliedTime] = useState('10:00');
  const [isLoading, setIsLoading] = useState(false);

  const [selectedJudge, setSelectedJudge] = useState({ judegId: 0, judgeName: '없음' });
  const [render, setRender] = useState(false);

  // Event Column API Call //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {

        const responseData = await fetchModule.getDataOfEventVer2('wod_record/rank/column/' + params.eventId, 'GET');

        if (responseData.status === 200) {
          if (responseData.data.columns.length > 0) setClickedScoreRuleId(responseData.data.columns[0].scoreRuleId);
          if (responseData.data.selectOptions.length > 0) setClickedSelectOptionId(responseData.data.selectOptions[0].selectOptionId);

          // setTournamentTitle(responseData.data.tournamentTitle);
          setOrganizer(responseData.data.organizerId);
          setEventTitle(responseData.data.eventTitle);
          setEventProfile(responseData.data.eventProfile);
          setDivisions(responseData.data.selectOptions);
          setColumns(responseData.data.columns);
        }
      }
    )();
  }, [])


  // 순위 결과 불러오기 //
  useEffect(() => {
    if (clickedScoreRuleId === -1 || clickedScoreRuleId == 0) return;

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfEventVer2('wod_record/rank/leaderboard/' + clickedScoreRuleId, 'GET');
        // console.log(responseData.data);
        if (responseData.status === 200) {
          if (clickedSelectOptionId === 0) setRanks(responseData.data.ranks);
          else {
            let rankData = responseData.data.ranks.slice();
            let finalRank = [];

            for (let i = 0; i < rankData.length; i++) {
              if (rankData[i].selectOptionId === clickedSelectOptionId) {
                finalRank.push(rankData[i]);
              }
            }

            setRanks(finalRank);
          }
          setIsLoading(false);
        }
        else {
          alert('순위 산출에 실패했습니다\n잠시 후 다시시도해주세요');
          setIsLoading(false);
        }
      }
    )();
  }, [clickedScoreRuleId, clickedSelectOptionId, render])

  // 저지 명단 API Call //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {

        const responseData = await fetchModule.getDataOfEventVer2('wod_record/judge', 'GET');

        if (responseData.status === 200) {
          setJudges(responseData.data);
        }
      }
    )();
  }, [])

  // 컬럼 텍스트 정리 //
  function decideColumnText(data) {
    let isExist = false;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].wodId === data.wodId
        && (columns[i].scoreRuleViewIndex !== 1)) {
        isExist = true;
        break;
      }
    }

    if (isExist) return data.wodSubTitle + '-' + String.fromCharCode(64 + data.scoreRuleViewIndex);
    else return data.wodSubTitle;
  }

  // 구분 너비 정리 //
  function decideDivisionWidth() {
    return (100 / divisions.length);
  }

  // 구분 데이터 텍스트 //
  function decideDivisionText(data) {
    return data.name;
  }

  // 전체 순위 등수표 결정 //
  function decidePlacement(data) {
    if (data.wodRecordId === 0 && clickedScoreRuleId !== 0) {
      return (
        <RankingNumberBox>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF'>{ranks.length}</Text>
        </RankingNumberBox>
      )
    }
    else {
      let rankImage = FirstPlaceImg;

      if (data.rank === 1) rankImage = FirstPlaceImg;
      else if (data.rank === 2) rankImage = SecondPlaceImg;
      else if (data.rank === 3) rankImage = ThirdPlaceImg;

      if (data.rank < 4) {
        return (
          <RankingLeaderBoxWrapper>
            <RankingLeaderBox src={rankImage} />
            <RankingImageTextWrapper>
              <Text style={{ marginTop: `-8px` }} fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF'>{data.rank}</Text>
            </RankingImageTextWrapper>
          </RankingLeaderBoxWrapper>
        )
      }
      else {
        return (
          <RankingNumberBox>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF'>{data.rank}</Text>
          </RankingNumberBox>
        );
      }
    }
  }

  // 기록 시간 표출 포맷 설정 //
  const formatTime = (min, sec, milliSec) => {
    const paddedMin = String(min ?? 0).padStart(2, '0');
    const paddedSec = String(sec ?? 0).padStart(2, '0');
    const paddedMilliSec = String(milliSec ?? 0).padStart(2, '0');
    
    if (paddedMilliSec === '00') return `${paddedMin}:${paddedSec}`;
    else return `${paddedMin}:${paddedSec}.${paddedMilliSec}`;
  };

  // 제출 및 저지 결과 표출 //
  const getScoreValueByPrefix = (record, prefix, tag, keyword, isSuccess, isUseTimeCap) => {
    const getField = (field) => {
      if (prefix) {
        // customValue는 camelCase 처리
        if (field === 'CustomValue') return record[`${prefix}CustomValue`];
        return record[`${prefix}${field}`];
      } else {
        // customValue는 소문자로 시작하는 필드
        if (field === 'CustomValue') return record['customValue'];
        return record[field.toLowerCase()];
      }
    };

    const round = getField('Round') ?? 0;
    const reps = getField('Reps') ?? 0;

    // ForTime + 실패자 (단, 시간 제한이 있는 경우에만)
    if (tag === 'ForTime' && isUseTimeCap === true && isSuccess === false) {
      return (
        <RecordTextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF'>{round}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>R</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF'>{reps}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>Reps</Text>
        </RecordTextWrapper>
      );
    }

    // AMRAP 또는 Rounds + Reps
    if (tag === 'AMRAP' || keyword === 'Rounds + Reps') {
      return (
        <RecordTextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF'>{round}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>R</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF'>{reps}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>Reps</Text>
        </RecordTextWrapper>
      );
    }

    // ForTime + 성공자: 시간 표출
    if ((tag === 'ForTime' || keyword === 'Time')) {
      const min = getField('Min');
      const sec = getField('Sec');
      const milliSec = getField('MilliSec');
      
      return formatTime(parseInt(min), parseInt(sec), parseInt(milliSec || "0"));
    }

    // CustomValue 기반 표출
    if (['Peek Watt', 'Max Speed', 'Distance', 'Weight', 'Point'].includes(keyword)) {
      return `${getField('CustomValue') ?? 0}`;
    }

    // Reps만 단독 표출
    if (keyword === 'Reps') {
      return `${reps}`;
    }

    return '';
  };


  // 결과 표출 단위 결정 //
  const getScoreLabel = (tag, keyword, isUseTimeCap, isSuccess, isTieBreak = false) => {
    // ✅ 1. TieBreak이면 무조건 'TieBreak'
    if (isTieBreak) return 'TieBreak';

    // ✅ 2. ForTime인데 시간제한이 있고 실패자면 → 라벨 없음 (Round+Reps 표출 중이므로)
    if (tag === 'ForTime' && isUseTimeCap && !isSuccess) return '';
    else if (tag === 'ForTime' && !isUseTimeCap) return 'Time';

    // ✅ 3. 나머지 키워드에 따라 단위 라벨 표기
    switch (keyword) {
      case 'Time': return 'Time';
      case 'Reps': return 'Reps';
      case 'Rounds + Reps': return '';
      case 'Distance': return 'm';
      case 'Weight': return 'lb';
      case 'Point': return 'Point';
      case 'Peek Watt': return 'Watt';
      case 'Max Speed': return 'Speed';
      case 'Not Scored': return '';
      default: return '';
    }
  };

  // 사용자 제출 데이터 정리 //
  function decideRecordViewBySubmitted(data) {
    if (data.wodRecordId === 0) {
      return (
        <RecordTextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF'>미제출</Text>
        </RecordTextWrapper>
      );
    }

    const mainScore = getScoreValueByPrefix(data, '', data.tag, data.scoreKeyword, data.isSuccess, data.isUseTimeCap);
    const mainLabel = getScoreLabel(data.tag, data.scoreKeyword, data.isUseTimeCap, data.isSuccess, false);
    const tieBreakScore = data.isUseTieBreak
      ? getScoreValueByPrefix(data, 'tieBreak', data.tieBreakTag, data.tieBreakScoreKeyword, data.tieBreakIsSuccess, data.tieBreakIsUseTimeCap)
      : '';
    const tieBreakLabel = data.isUseTieBreak
      ? getScoreLabel(data.tieBreakTag, data.tieBreakScoreKeyword, data.tieBreakIsUseTimeCap, data.tieBreakIsSuccess, true)
      : '';

    return (
      <RecordTextWrapper>
        {(data.tag === 'AMRAP' || data.scoreKeyword === 'Rounds + Reps') ? mainScore :
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF'>{mainScore}</Text>}
        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>{mainLabel}</Text>
        {(data.tieBreakTag === 'AMRAP' || data.tieBreakScoreKeyword === 'Rounds + Reps') ? tieBreakScore :
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF'>{tieBreakScore}</Text>}
        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>{tieBreakLabel}</Text>
      </RecordTextWrapper>
    );
  }

  // 저지 데이터 정리 //
  function decideRecordViewByJudge(data) {
    if (!data.judgeId) {
      return (
        <RecordTextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF'>미제출</Text>
        </RecordTextWrapper>
      );
    }

    const mainScore = getScoreValueByPrefix(data, 'judge', data.tag, data.scoreKeyword, data.judgeIsSuccess, data.isUseTimeCap);
    const mainLabel = getScoreLabel(data.tag, data.scoreKeyword, data.isUseTimeCap, data.judgeIsSuccess, false);
    const tieBreakScore = data.isUseTieBreak
      ? getScoreValueByPrefix(data, 'judgeTieBreak', data.tieBreakTag, data.tieBreakScoreKeyword, data.judgeTieBreakIsSuccess, data.tieBreakIsUseTimeCap)
      : '';
    const tieBreakLabel = data.isUseTieBreak
      ? getScoreLabel(data.tieBreakTag, data.tieBreakScoreKeyword, data.tieBreakIsUseTimeCap, data.judgeTieBreakIsSuccess, true)
      : '';

    return (
      <RecordTextWrapper>
        {(data.tag === 'AMRAP' || data.scoreKeyword === 'Rounds + Reps') ? mainScore :
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF'>{mainScore}</Text>}
        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>{mainLabel}</Text>
        {(data.tieBreakTag === 'AMRAP' || data.tieBreakScoreKeyword === 'Rounds + Reps') ? tieBreakScore :
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF'>{tieBreakScore}</Text>}
        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>{tieBreakLabel}</Text>
      </RecordTextWrapper>
    );
  }

  // 메인 기록 정리 //
  // 제출 기록 타임캡 안에 성공 클릭시 //
  function onChangeJudgeIsSuccess(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeIsSuccess = value;
    setClickedRankDetail(data);
  }

  // 제출 기록 시간(분) 변경시 //
  function onChangeJudgeMin(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeMin = value;
    setClickedRankDetail(data);
  }

  // 제출 기록 시간(초) 변경시 //
  function onChangeJudgeSec(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeSec = value;
    setClickedRankDetail(data);
  }

  // 제출 기록 시간(밀리초) 변경시 //
  function onChangeJudgeMilliSec(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeMilliSec = value;
    setClickedRankDetail(data);
  }

  // 제출 기록 라운드 변경시 //
  function onChangeJudgeRound(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeRound = value;
    setClickedRankDetail(data);
  }

  // 제출 기록 렙수 변경시 //
  function onChangeJudgeReps(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeReps = value;
    setClickedRankDetail(data);
  }

  // 제출 기록 커스텀 변수 변경시 //
  function onChangeJudgeCustomValue(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeCustomValue = value;
    setClickedRankDetail(data);
  }
  // 메인 기록 정리 //


  // 타이브레이크 기록 정리 //
  // 제출 기록 타임캡 안에 성공 클릭시 //
  function onChangeJudgeTieBreakIsSuccess(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeTieBreakIsSuccess = value;
    setClickedRankDetail(data);
  }

  // 제출 기록 시간(분) 변경시 //
  function onChangeJudgeTieBreakMin(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeTieBreakMin = value;
    setClickedRankDetail(data);
  }

  // 제출 기록 시간(초) 변경시 //
  function onChangeJudgeTieBreakSec(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeTieBreakSec = value;
    setClickedRankDetail(data);
  }

  // 제출 기록 시간(밀리초) 변경시 //
  function onChangeJudgeTieBreakMilliSec(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeTieBreakMilliSec = value;
    setClickedRankDetail(data);
  }

  // 제출 기록 라운드 변경시 //
  function onChangeJudgeTieBreakRound(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeTieBreakRound = value;
    setClickedRankDetail(data);
  }

  // 제출 기록 렙수 변경시 //
  function onChangeJudgeTieBreakReps(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeTieBreakReps = value;
    setClickedRankDetail(data);
  }

  // 제출 기록 커스텀 변수 변경시 //
  function onChangeJudgeTieBreakCustomValue(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeTieBreakCustomValue = value;
    setClickedRankDetail(data);
  }

  // 저지 결과 기록 
  function onChangeJudgeNote(value) {
    let data = lodash.cloneDeep(clickedRankDetail);

    data.judgeNote = value;
    setClickedRankDetail(data);
  }
  // 타이브레이크 기록 정리 //


  // 뒤로가기 버튼 클릭시 //
  function onClickGoBack() {
    navigate('/note/' + organizerId);
  }

  // 기록 기준 클릭시 //
  function onClickScoreRule(data) {
    setClickedRankDetail(undefined);
    setClickedRankDetailIndex(-1);
    setClickedScoreRuleId(data.scoreRuleId);
  }

  // 랭킹 세션 구분 변경 클릭시 //
  function onClickSelectOptionId(value) {
    setIsLoading(true);
    setRanks([]);
    setClickedSelectOptionId(value);
  }

  // 기록 자세히보기 클릭시 //
  function onClickRankDetail(data, index) {
    // setClickedRankDetail(undefined);
    // console.log(data);
    if (data.judgeId === undefined && judges.length > 0) setSelectedJudge(judges[0]);
    else {
      const result = judges.find(item => item.judgeId === data.judgeAdminId);
      
      setSelectedJudge({ judgeId: result.judgeId, judgeName: result.judgeName });
    }

    if (data.appliedDate === undefined) {
      const defaultDate = moment().startOf('day').add(7, 'days');

      setAppliedDate(defaultDate);
      setAppliedTime('10:00');
    }
    else {
      const applied = moment(data.appliedDate);

      setAppliedDate(applied.clone().startOf('day'));
      setAppliedTime(applied.format('HH:mm'));
    }

    if (data.judgeNote === undefined) data.judgeNote = '';

    setClickedRankDetail(data);
    setClickedRankDetailIndex(index);
  }

  // 저장 클릭시 //
  function onClickSave(isImmediately) {

    if (clickedRankDetail === undefined) {
      alert('저장할 기록을 선택해주세요');
      return;
    }
    else if (isInProgress) {
      alert('저장을 진행중입니다');
      return;
    }
    // else if (clickedRankDetail.wodRecordId === 0) {
    //   alert('제출하지 않은 기록은 저지를 진행할 수 없습니다');
    //   return;
    // }

    const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;

    if (!timePattern.test(appliedTime) && appliedTime !== '') {
      alert('적용시간을 올바르게 입력해주세요');
      return;
    }

    setIsInProgress(true);

    let newAppliedTime = appliedTime === '' ? '00:00' : appliedTime;
    let finalAppliedDate = appliedDate.format('YYYY-MM-DDT') + newAppliedTime + ':00';

    if (isImmediately) finalAppliedDate = moment().format('YYYY-MM-DDT00:00:00');

    let requestData = {
      judgeId: clickedRankDetail.judgeId === undefined ? 0 : clickedRankDetail.judgeId,
      wodRecordId: clickedRankDetail.wodRecordId,
      eventId: parseInt(params.eventId),
      wodId: clickedRankDetail.wodId,
      scoreRuleId: clickedRankDetail.scoreRuleId,
      isSuccess: clickedRankDetail.judgeIsSuccess ?? false,
      min: parseInt(clickedRankDetail.judgeMin),
      sec: clickedRankDetail.judgeSec + '.' + clickedRankDetail.judgeMilliSec,
      round: parseInt(clickedRankDetail.judgeRound),
      reps: parseInt(clickedRankDetail.judgeReps),
      roundOfCount: '',
      customValue: parseInt(clickedRankDetail.judgeCustomValue),

      teamId: parseInt(clickedRankDetail.teamId),
      userId: clickedRankDetail.userId,

      tieBreakIsSuccess: clickedRankDetail.judgeTieBreakIsSuccess ?? false,
      tieBreakMin: parseInt(clickedRankDetail.judgeTieBreakMin),
      tieBreakSec: clickedRankDetail.judgeTieBreakSec + '.' + clickedRankDetail.judgeTieBreakMilliSec,
      tieBreakRound: parseInt(clickedRankDetail.judgeTieBreakRound),
      tieBreakReps: parseInt(clickedRankDetail.judgeTieBreakReps),
      tieBreakRoundOfCount: '',
      tieBreakCustomValue: parseInt(clickedRankDetail.judgeTieBreakCustomValue),

      judgeAdminId: selectedJudge.judgeId,
      judgeAdminName: selectedJudge.judgeName,
      judgeNote: clickedRankDetail.judgeNote,
      appliedDate: finalAppliedDate
    }

    // console.log(requestData);
    // console.log(clickedRankDetail);
    // setIsInProgress(false);
    // setIsInProgress(false);
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfEventVer2('judge/save', 'POST', requestData);
        // console.log(responseData.data);
        if (responseData.status === 200) {
          const applied = moment(responseData.data.appliedDate);

          setAppliedDate(applied.clone().startOf('day'));
          setAppliedTime(applied.format('HH:mm'));

          setRender(!render);
          setIsInProgress(false);
        }
        else {
          alert('저장에 실패했습니다\n잠시 후 다시시도해주세요');
          setIsInProgress(false);
        }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      {isClickedAppliedDate && <AppliedDateSelectModal appliedDate={appliedDate} setAppliedDate={setAppliedDate} onClickExit={() => setIsClickedAppliedDate(false)} />}
      {isInProgress && <LoadingView />}
      <TopNavigationWrapper>
        <NavigateButtonWrapper>
          <GoBackButton onClick={onClickGoBack}>
            <GoBackInnerWrapper>
              <ArrowImage src={WhiteLeftArrow} />
            </GoBackInnerWrapper>
          </GoBackButton>
          <EventProfileBox>
            <EventProfile src={eventProfile === '' ? ProfilePath : eventProfile} />
          </EventProfileBox>
          <EventTitleBox>
            <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#FFFFFF' cursor='default'>{eventTitle}</Text>
          </EventTitleBox>
          {
            columns.map((data, index) => (
              <WodTitleBox
                key={'LeaderBoardScoreRule-' + index}
                isClicked={data.scoreRuleId === clickedScoreRuleId}
                onClick={() => onClickScoreRule(data)}>
                <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#FFFFFF' cursor='pointer'>{decideColumnText(data)}</Text>
              </WodTitleBox>
            ))
          }
        </NavigateButtonWrapper>
      </TopNavigationWrapper>
      <AppliedDateSaveButtonWrapper>
        <AppliedDateWrapper>
          <DateComponentWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>순위 자동 재적용일</Text>
            <DateButton onClick={() => setIsClickedAppliedDate(true)}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>{appliedDate.format('YYYY.MM.DD')}</Text>
              <CalenderImage src={CalenderIcon} />
            </DateButton>
            <AppliedTimeInput isEdit={true} value={appliedTime} setValue={setAppliedTime} placeholder='00:00' />
          </DateComponentWrapper>
        </AppliedDateWrapper>
        <ImmediatelyAppliedButton onClick={() => onClickSave(true)}>
          <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#FFFFFF' cursor='pointer'>순위 바로 적용</Text>
        </ImmediatelyAppliedButton>
      </AppliedDateSaveButtonWrapper>
      <LeaderBoardWrapper>
        <RankBoxWrapper>
          {
            divisions.length > 0 &&
            <DivisionBoxWrapper>
              {
                divisions.map((data, index) => (
                  <DivisionBox
                    key={'DivisionBox-' + index}
                    width={decideDivisionWidth()}
                    isClicked={clickedSelectOptionId === data.selectOptionId}
                    onClick={() => onClickSelectOptionId(data.selectOptionId)}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={15} color='#FFFFFF'>{decideDivisionText(data)}</Text>
                  </DivisionBox>
                ))
              }
            </DivisionBoxWrapper>
          }
          <RankingInfoBox>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='pointer'>순위</Text>
            <TotalInfoWrapper>
              {
                ranks.map((data, index) => (
                  <InfoWrapper key={'JudgeRank-' + index}>
                    <PlacementView>
                      {decidePlacement(data)}
                      {
                        data.judgeId !== undefined &&
                        <JudgeCompleteBox>
                          <Text fontFamily='NotoSansKR-Medium' fontSize={10} color='#FFFFFF' cursor='pointer'>저지완료</Text>
                        </JudgeCompleteBox>
                      }
                    </PlacementView>
                    <InfoBox isClicked={index === clickedRankDetailIndex} onClick={() => onClickRankDetail(data, index)}>
                      <LeftWrapper>
                        <Profile src={data.profile === '' ? NoneProfile : data.profile} />
                        <InfoTextWrapper>
                          <InnerInfoTextWrapper>
                            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{data.name}</Text>
                          </InnerInfoTextWrapper>
                          <RecordBox style={{ marginTop: '5px' }}>
                            <RecordDivisionViewBox backgroundColor='#6DD49E'>
                              <Text fontFamily='NotoSansKR-Medium' fontSize={10} color='#FFFFFF' cursor='pointer'>제출기록</Text>
                            </RecordDivisionViewBox>
                            {decideRecordViewBySubmitted(data)}
                          </RecordBox>
                          {
                            data.judgeId !== undefined &&
                            <RecordBox>
                              <Text fontFamily='NotoSansKR-Medium' fontSize={10} color='#FF8B48' cursor='pointer'>{data.judgeAdminName}</Text>
                            </RecordBox>
                          }
                          {
                            data.judgeId !== undefined &&
                            <RecordBox>
                              <RecordDivisionViewBox backgroundColor='#FF8B48'>
                                <Text fontFamily='NotoSansKR-Medium' fontSize={10} color='#FFFFFF' cursor='pointer'>저지기록</Text>
                              </RecordDivisionViewBox>
                              {decideRecordViewByJudge(data)}
                            </RecordBox>
                          }
                          {
                            data.judgeId !== undefined &&
                            <JudgeNoteBox>
                              <PreText fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>{data.judgeNote}</PreText>
                            </JudgeNoteBox>
                          }
                        </InfoTextWrapper>
                      </LeftWrapper>
                      {
                        index === clickedRankDetailIndex &&
                        <DetailButtonWrapper>
                          <DetailButton isClicked={data.isClicked} src={RightImg} />
                        </DetailButtonWrapper>
                      }
                    </InfoBox>
                  </InfoWrapper>
                ))
              }
            </TotalInfoWrapper>
          </RankingInfoBox>
        </RankBoxWrapper>

        <HeightGreenDivisionLine />
        {
          clickedRankDetail === undefined &&
          <EmptyJudgeBoxWrapper>
            <LogoWrapper>
              <LogoImage src={EmptyLogo} />
              <Text fontFamily='NotoSansKR-Medium' fontSize={18} color='#454549' cursor='default'>기록을 선택해주세요</Text>
            </LogoWrapper>
          </EmptyJudgeBoxWrapper>
        }
        {
          clickedRankDetail !== undefined &&
          <JudgeBoxWrapper>
            <JudgeColumnWrapper>
              <JudgeColumn backgroundColor='#6DD49E'>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>선수 기록</Text>
              </JudgeColumn>
            </JudgeColumnWrapper>
            <JudgeWrapper>
              <DetailInfoBox>
                <LeftWrapper>
                  <Profile src={clickedRankDetail.profile === '' ? NoneProfile : clickedRankDetail.profile} />
                  <InfoTextWrapper>
                    <InnerInfoTextWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{clickedRankDetail.name}</Text>
                    </InnerInfoTextWrapper>
                    <RecordBox style={{ marginTop: '5px' }}>
                      {decideRecordViewBySubmitted(clickedRankDetail)}
                    </RecordBox>
                  </InfoTextWrapper>
                </LeftWrapper>
              </DetailInfoBox>
              <VideoViewBoxWrapper>
                <TitleTextWrapper>
                  <Circle backgroundColor='#6DD49E' />
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>제출 영상</Text>
                </TitleTextWrapper>
                {
                  (clickedRankDetail.videoUrl !== undefined && clickedRankDetail.videoUrl !== '') ?
                    <PlaylistVideoBox
                      videoUrl={clickedRankDetail.videoUrl}
                      marginTop='20px'
                      width='100%'
                      height='268px'
                      borderRadius='5px'
                      thumbnailColor='#2F2F32'
                      noticeColor='#BDBDBD'
                      noticeText='재생목록이 비공개로 설정되어 있어 재생할 수 없습니다'
                      buttonText='YouTube에서 보기' />
                    :
                    <VideoViewBox>
                      <LogoWrapper>
                        <LogoImage src={EmptyLogo} />
                        <Text fontFamily='NotoSansKR-Medium' fontSize={18} color='#454549' cursor='default'>제출한 영상이 없습니다</Text>
                      </LogoWrapper>
                    </VideoViewBox>
                }
              </VideoViewBoxWrapper>

              <SubmitBox data={clickedRankDetail} />
            </JudgeWrapper>

            <JudgeDivisionLine />
              
            <JudgeColumnWrapper>
              <JudgeColumn backgroundColor='#FF8B48'>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>저지 노트</Text>
              </JudgeColumn>
            </JudgeColumnWrapper>
            <JudgeWrapper>
              <JudgeSelectBoxWrapper>
                <TitleTextWrapper>
                  <Circle backgroundColor='#FF8B48' />
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>저지 이름</Text>
                </TitleTextWrapper>
                <JudgeSelectBox options={judges} value={selectedJudge} setValue={setSelectedJudge} />
              </JudgeSelectBoxWrapper>

              <JudgeBox
                data={clickedRankDetail}

                onChangeJudgeIsSuccess={onChangeJudgeIsSuccess}
                onChangeJudgeMin={onChangeJudgeMin}
                onChangeJudgeSec={onChangeJudgeSec}
                onChangeJudgeMilliSec={onChangeJudgeMilliSec}
                onChangeJudgeRound={onChangeJudgeRound}
                onChangeJudgeReps={onChangeJudgeReps}
                onChangeJudgeCustomValue={onChangeJudgeCustomValue}

                onChangeJudgeTieBreakIsSuccess={onChangeJudgeTieBreakIsSuccess}
                onChangeJudgeTieBreakMin={onChangeJudgeTieBreakMin}
                onChangeJudgeTieBreakSec={onChangeJudgeTieBreakSec}
                onChangeJudgeTieBreakMilliSec={onChangeJudgeTieBreakMilliSec}
                onChangeJudgeTieBreakRound={onChangeJudgeTieBreakRound}
                onChangeJudgeTieBreakReps={onChangeJudgeTieBreakReps}
                onChangeJudgeTieBreakCustomValue={onChangeJudgeTieBreakCustomValue} />


              <JudgeSelectBoxWrapper style={{ marginTop: '10px' }}>
                <TitleTextWrapper>
                  <Circle backgroundColor='#FF8B48' />
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>저지 결과 노트</Text>
                </TitleTextWrapper>
                <JudgeNoteTextAreaWrapper>
                  <JudgeNoteTextArea value={clickedRankDetail.judgeNote} setValue={onChangeJudgeNote} placeholder='저지 결과를 적어주세요' />
                </JudgeNoteTextAreaWrapper>
              </JudgeSelectBoxWrapper>
              <JudgeSaveButton onClick={() => onClickSave(false)}>
                <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#FFFFFF' cursor='pointer'>저지 기록 저장하기</Text>
              </JudgeSaveButton>
            </JudgeWrapper>
          </JudgeBoxWrapper>
        }
      </LeaderBoardWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 94%;
  height: 100%;
`;

const TopNavigationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const NavigateButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  flex-wrap: wrap;

  width: 100%;

  gap: 10px;
`;

const GoBackButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 32px;
  height: 32px;

  border-radius: 32px;
  background-color: #FFFFFF;

  :hover {
    cursor: pointer;
  }
`;

const GoBackInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 28px;
  height: 28px;

  border-radius: 30px;
  background-color: #000000;
`;

const ArrowImage = styled.img`
  width: 8px;
  height: 13px;
`;

const EventProfileBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 42px;
  height: 42px;

  border-radius: 5px;
  
  overflow: hidden;
`;

const EventProfile = styled.img`
  width: 100%;
  height: 100%;
`;

const EventTitleBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px;

  height: 22px;

  border-radius: 10px;
  background-color: #2F2F32;
`;

const WodTitleBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 10px;

  min-width: 20px;
  height: 22px;

  border-radius: 10px;
  background-color: ${props => props.isClicked ? `#6DD49E` : `#000000`};

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const WidthDivisionLine = styled.div`
  margin: 35px 0px;

  padding-top: 1px;

  width: 100%;
  height: 1px;

  border-radius: 2px;
  background-color: #E5E5E5;
`;

const AppliedDateSaveButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 12px;

  width: 100%;

  gap: 20px;
`;

const AppliedDateWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 5px;
`;

const ImmediatelyAppliedButton = styled.div`
  display: flex;
  flex-direction: colimn;

  justify-content: center;
  align-items: center;

  width: 104px;
  height: 36px;

  border-radius: 30px;
  background-color: #6DD49E;

  :hover {
    cursor: pointer;
  }
`;

const LeaderBoardWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 12px;

  width: 100%;
`;

const RankBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 48%;
  height: calc(100vh - 190px);

  border-radius: 10px 10px 5px 5px;
  background-color: #2F2F32;

  overflow: scroll;

  &::-webkit-scrollbar {
    width: 0px;
    height: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    border: 2px solid transparent;
    background-color: #000000;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-track {
    // background-color: #F9F9F9;
    border-radius: 200px;
    opacity: 0;
  }
`;

const DivisionBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;

  background-color: #000000;
`;

const DivisionBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: ${props => props.width}%;
  height: 32px;

  border-radius: 10px 10px 0px 0px;
  background-color: ${props => props.isClicked ? '#FFB800' : '#17171B'};

  :hover {
    cursor: pointer;
  }
  
  transition: all 0.3s ease-in-out;
`;

const HeightGreenDivisionLine = styled.div`
  padding: 5px 0px;

  width: 2px;
  height: calc(100% - 10px);

  border-radius: 2px;
  background-color: #4E8168;
`;

const JudgeBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 15px 0px;

  width: 48%;
  height: calc(100vh - 220px);

  // border-radius: 5px;
  // background-color: #2F2F32;

  overflow: scroll;

  &::-webkit-scrollbar {
    width: 0px;
    height: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    border: 2px solid transparent;
    background-color: #000000;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-track {
    // background-color: #F9F9F9;
    border-radius: 200px;
    opacity: 0;
  }
`;

const JudgeColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 94%;
`;

const JudgeColumn = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 88px;
  height: 32px;

  border-radius: 10px 10px 0px 0px;
  background-color: ${props => props.backgroundColor};
`;

const JudgeWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 94%;

  border-radius: 0px 5px 5px 5px;
  background-color: #17171B; 
`;

const EmptyJudgeBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 15px 0px;

  width: 48%;
  height: calc(100vh - 220px);

  border-radius: 5px;
  background-color: #2F2F32;

  overflow: scroll;

  &::-webkit-scrollbar {
    width: 0px;
    height: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    border: 2px solid transparent;
    background-color: #000000;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-track {
    // background-color: #F9F9F9;
    border-radius: 200px;
    opacity: 0;
  }
`;

const JudgeDivisionLine = styled.div`
  margin: 30px 0px;

  width: 100%;
  height: 1px;

  background-color: #17171B;
`;

const RankingInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 10px;

  width: 94%;
`;

const TotalInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 15px;

  width: 100%;

  gap: 20px;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;

  gap: 5px;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 12px;

  width: 100%;
  
  border-radius: 12px;
  border: ${props => props.isClicked ? `1px solid #6DD49E` : `1px solid #17171B`};
  background-color: ${props => props.isClicked ? `#214030` : `#17171B`};

  :hover {
    cursor: pointer;

    border: 1px solid #6DD49E;
    background-color: #214030;
  }

  transition: all 0.3s ease-in-out;
`;

const DetailInfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 12px;

  width: calc(100% - 24px);

  // border-radius: 12px;
  // background-color: #17171B;
`;

const JudgeSelectBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px 12px;

  width: calc(100% - 24px);

  gap: 20px;

  // border-radius: 12px;
  // background-color: #17171B;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  width: calc(100% - 30px);

  gap: 8px;
`;

const Profile = styled.img`
  width: 40px;
  height: 40px;

  border-radius: 6px;
`;

const InfoTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: calc(100% - 48px);
`;

const InnerInfoTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 6px;
`;

const RecordBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const RecordDivisionViewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 43px;
  height: 15px;

  border-radius: 3px;
  background-color: ${props => props.backgroundColor};

  :hover {
    cursor: pointer;
  }
`;

const RecordTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const JudgeNoteBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding-top: 10px;
  margin-top: 10px;

  width: 100%;

  border-top: 1px solid #FFFFFF;
`;

const DetailButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 22px;
  height: 100%;
`;

const DetailButton = styled.img`
  width: 9.6px;
  height: 17.7px;

  transform: ${props => props.isClicked ? `rotateZ(90deg)` : `rotateZ(0deg)`};

  transition: all 0.3s ease-in-out;
`;

const PlacementView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 40px;

  gap: 5px
`;

const JudgeCompleteBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 40px;
  height: 17px;

  border-radius: 5px;
  background-color: #FF8B48;

  :hover {
    cursor: pointer;
  }
`;

const RankingLeaderBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const RankingLeaderBox = styled.img`
  width: 40px;
  height: 40px;
`;

const RankingImageTextWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // margin-top: -10px;
`;

const RankingNumberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  border-radius: 12px;
  background-color: #E0E0E0;
`;

const DateComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 4px;
`;

const DateButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 131px;
  height: 28px;

  gap: 8px;

  border: 2px solid #909090;
  border-radius: 8px;
  background-color: #2F2F32;

  :hover {
    cursor: pointer;
  }
`;

const VideoViewBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 10px 15px 30px 15px;

  width: calc(100% - 30px);
  
  // border-radius: 12px;
  // background-color: #17171B;
`;

const VideoViewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: 100%;
  // height: 277px;
  height: 268px;
  
  border-radius: 5px;
  background-color: transprent;

  overflow: hidden;
`;

const CalenderImage = styled.img`
  width: 18px;
  height: 18px;
`;

const TitleTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const Circle = styled.div`
  width: 10px;
  height: 10px;

  border-radius: 10px;
  background-color: ${props => props.backgroundColor};
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  gap: 8px;
`;

const LogoImage = styled.img`
  width: 150px;
  height: 150px;
`;

const JudgeSaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 16px;

  width: 100%;
  min-height: 36px;

  border-radius: 5px;
  background-color: #6DD49E;

  :hover {
    cursor: pointer;
  }
`;

const JudgeNoteTextAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  
  border-radius: 5px;
  border: 1px solid #CBCBCB;
  background-color: #2F2F32;
`;

const PreText = styled.pre`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: pre-wrap;
  word-break: break-word;

  :hover {
    cursor: default;
  }
`;

const Text = styled.div`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;

